const isExternalUrl = (string) => /^(http|mailto)/.test(string);

export default isExternalUrl;
